import { makeAutoObservable } from "mobx";

export class Screen {
  highlighted = false;
  zIndex = 100;

  constructor(screen) {
    this.color = screen.color;
    this.createdAt = screen.createdAt;
    this.id = screen.id;
    this.name = screen.name;
    this.owner = screen.owner;
    this.ownerScreenBackgroundContent = screen.ownerScreenBackgroundContent;
    this.panel = screen.panel ? screen.panel : screen.userPanel;
    this.panelRows = screen.panelRows;
    this.panelID = screen.panelID;
    this.panelColumns = screen.panelColumns;
    this.pressedModule = screen.pressedModule;
    this.pressedPanel = screen.pressedPanel;
    this.project = screen.project;
    this.projectID = screen.projectID;
    this.startX = screen.startX;
    this.startY = screen.startY;
    this.updatedAt = screen.updatedAt;
    this.rotation = screen.rotation;
    this.panelArray = screen.panelArray;
    this.moduleArray = screen.moduleArray;
    makeAutoObservable(this);
  }

  setHighlight(bool) {
    this.highlighted = bool;
  }
  setZindex(number) {
    this.zIndex = number;
  }
  setPanelArray(panelArray) {
    this.panelArray = panelArray;
  }
}
